export default __webpack_public_path__ + "static/media/Ballroll_00047.1ea9f2a8.png";